import { render, staticRenderFns } from "./StaffLocationVerification.vue?vue&type=template&id=14c967d4&scoped=true"
import script from "./StaffLocationVerification.vue?vue&type=script&lang=js"
export * from "./StaffLocationVerification.vue?vue&type=script&lang=js"
import style0 from "./StaffLocationVerification.vue?vue&type=style&index=0&id=14c967d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c967d4",
  null
  
)

export default component.exports